import { FieldConfig } from "../../../SetupFormGenerator/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";

export enum TaxableBenefits {
  CAR = "Car",
  COMMUTER_ALLOWANCE = "Commuter Allowance",
  LIVING_ACCOMMODATIONS = "Living Accommodations",
  LOANS = "Loans",
  MEAL_ALLOWANCE = "Meal Allowance",
  MEDICAL_INSURANCE = "Medical Insurance",
  PHONE_AND_INTERNET = "Phone & Internet",
  RECREATIONAL_FACILITIES_AND_DUES = "Recreational Facilities & Dues",
  REMOTE_WORK = "Remote Work",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const TaxableBenefitsTypeMessage = null;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
